const useTelegramInit = () => {
  const route = useRoute();
  const router = useRouter();
  const telegram = window.Telegram?.WebApp as any;

  if (telegram?.initData) {
    telegram.ready();
    telegram.isClosingConfirmationEnabled = true; // Включение подтверждения закрытия
    telegram.isVerticalSwipesEnabled = false; // Отключение вертикальных свайпов
    telegram.setBackgroundColor("#ffffff"); // Цвет фона
    telegram.setHeaderColor("#ffffff"); // Цвет заголовка

    const isDesktop = ["tdesktop", "macos", "weba", "webk"].includes(telegram.platform);
    const isTablet = window.innerWidth >= 768;

    if (telegram.isVersionAtLeast("8.0") && (isDesktop || isTablet)) {
      telegram.requestFullscreen();
    } else {
      telegram.expand();
    }

    useTelegramButtonBack(telegram, router, route); // Инициализация кнопки "Назад"
    document.body.classList.add("telegram");
  }
};

export { useTelegramInit };
